import { useQuery } from '@tanstack/react-query'

import { getDocsContent } from '@pepper/utils/src/api/editor/editor'

type Props = {
  assignmentId: string
}

const fetchDocsContent = async (itemId: string) => {
  const response = await getDocsContent({
    id: itemId
  })
  return response.data?.word_count
}

export function useGetWordCount({ assignmentId }: Props) {
  return useQuery({
    queryKey: ['docsContent', assignmentId],
    queryFn: () => fetchDocsContent(assignmentId)
  })
}
